import { useLanguage } from '@i18n/useLanguage'
import Column from '@app/components/layout/Column'
import { i18n } from '@i18n/index'
import { TextLink } from '@app/components/core/link/TextLink'
import { MegaMenuLinks } from '../blocks/common'
import { MegaMenuMobileItem } from '../blocks/MegaMenuMobileItem'
import { faUser, faHouseBuilding } from '@fortawesome/pro-solid-svg-icons'
import { Style } from 'inlines'

const textLinkStyle: Style = { textDecoration: 'none' }

export const StartMenu = () => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.nav.megaMenu.startMenu

  return (
    <Column gap="1rem" style={{ alignSelf: 'stretch', flexGrow: 1 }}>
      <MegaMenuMobileItem
        to={MegaMenuLinks.startInitiativeArticle}
        icon={faUser}
        label={translations.citizens.label}
        description={translations.citizens.description}
        backgroundColor="var(--brand-tertiary)"
      >
        <TextLink
          to={MegaMenuLinks.startInitiativeArticle}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.citizens.links.startInitiative}
        </TextLink>
        <TextLink
          to={MegaMenuLinks.startGroupArticle}
          size="medium"
          containerStyle={textLinkStyle}
        >
          {translations.citizens.links.registerProject}
        </TextLink>
      </MegaMenuMobileItem>
      <MegaMenuMobileItem
        to={MegaMenuLinks.startDeveloperArticle}
        icon={faHouseBuilding}
        label={translations.companies.label}
        description={translations.companies.description}
        backgroundColor="var(--palette-yellow-300)"
      />
    </Column>
  )
}
